import React from 'react';
import { Download, Filter, Search, ChevronDown, FileText } from 'lucide-react';
// Mock data based on screenshot
const WORKERS = [{
  id: 1,
  name: 'A.B. Olevic',
  phone: '+16466090377',
  contractor: 'Broadway Construction Group',
  prof: 'General Contractor',
  sticker: '-',
  site: 'Court Square LIC',
  role: 'Superintendent',
  image: 'https://i.pravatar.cc/150?u=1'
}, {
  id: 2,
  name: 'Diego Atariguana',
  phone: '+19293331080',
  contractor: '(AV MECHAN) AV Mechanic LLC',
  prof: 'VENDOR',
  sticker: '-',
  site: '251 Douglass Street, Block 412 Lot 50',
  role: '',
  image: 'https://i.pravatar.cc/150?u=2'
}, {
  id: 3,
  name: 'Pascual Rosas',
  phone: '+13473256208',
  contractor: '(AV MECHAN) AV Mechanic LLC',
  prof: 'VENDOR',
  sticker: '-',
  site: '251 Douglass Street, Block 412 Lot 50',
  role: '',
  image: 'https://i.pravatar.cc/150?u=3'
}, {
  id: 4,
  name: 'Asllan Gjokola',
  phone: '+19293679713',
  contractor: '(AV MECHAN) AV Mechanic LLC',
  prof: 'VENDOR',
  sticker: '-',
  site: '251 Douglass Street, Block 412 Lot 50',
  role: '',
  image: 'https://i.pravatar.cc/150?u=4'
}, {
  id: 5,
  name: 'Jorge Andreaggi',
  phone: '+19739531384',
  contractor: '(BCG) Broadway Construction Group',
  prof: 'VENDOR',
  sticker: '061',
  site: '99 Claremont Ave',
  role: 'Project Manager',
  image: 'https://i.pravatar.cc/150?u=5'
}, {
  id: 6,
  name: 'Byron Taylor',
  phone: '+15163517451',
  contractor: '(BCG) Broadway Construction Group',
  prof: 'VENDOR',
  sticker: '144',
  site: '99 Claremont Ave',
  role: 'Project Manager',
  image: 'https://i.pravatar.cc/150?u=6'
}, {
  id: 7,
  name: 'Jesse Gopeesingh',
  phone: '+13474999543',
  contractor: '(BCG) Broadway Construction Group',
  prof: 'VENDOR',
  sticker: '467',
  site: '99 Claremont Ave',
  role: 'Project Manager',
  image: 'https://i.pravatar.cc/150?u=7'
}, {
  id: 8,
  name: 'Victor Penaranda',
  phone: '+19172882768',
  contractor: '(BIG APPLE) Big Apple Testing',
  prof: 'VENDOR',
  sticker: '601',
  site: '99 Claremont Ave',
  role: '',
  image: 'https://i.pravatar.cc/150?u=8'
}, {
  id: 9,
  name: 'Alvaro Reyas',
  phone: '+13478587250',
  contractor: '(CHARNEY CC) Charney Companies LLC',
  prof: 'VENDOR',
  sticker: '465',
  site: '99 Claremont Ave',
  role: '',
  image: 'https://i.pravatar.cc/150?u=9'
}, {
  id: 10,
  name: 'MARIA CLAUDINA YUCAILLA',
  phone: '+19296712337',
  contractor: '(Clear Path) Clear Path Contracting LLC',
  prof: 'VENDOR',
  sticker: '-',
  site: '251 Douglass Street, Block 412 Lot 50',
  role: '',
  image: 'https://i.pravatar.cc/150?u=10'
}];
export function WorkersTable() {
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200" data-id="element-4043">
      {/* Toolbar */}
      <div className="p-4 border-b border-gray-200 flex flex-col sm:flex-row justify-between items-center gap-4" data-id="element-4044">
        <div className="text-lg font-medium text-gray-900" data-id="element-4045">4681 results</div>

        <div className="flex items-center gap-3 w-full sm:w-auto" data-id="element-4046">
          <div className="flex border border-gray-300 rounded-md overflow-hidden" data-id="element-4047">
            <button className="px-3 py-2 bg-gray-50 border-r border-gray-300 text-sm text-gray-700 flex items-center gap-2 hover:bg-gray-100" data-id="element-4048">
              All <ChevronDown size={14} data-id="element-4049" />
            </button>
            <div className="relative" data-id="element-4050">
              <input type="text" placeholder="Search" className="pl-3 pr-8 py-2 text-sm outline-none w-48" data-id="element-4051" />
            </div>
          </div>

          <button className="px-4 py-2 border border-gray-300 rounded-md text-sm text-gray-700 flex items-center gap-2 hover:bg-gray-50" data-id="element-4052">
            <Filter size={16} data-id="element-4053" />
            Filters
          </button>

          <button className="px-4 py-2 border border-gray-300 rounded-md text-sm text-gray-700 flex items-center gap-2 hover:bg-gray-50" data-id="element-4054">
            <Download size={16} data-id="element-4055" />
            Download
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto" data-id="element-4056">
        <table className="w-full text-left border-collapse" data-id="element-4057">
          <thead data-id="element-4058">
            <tr className="bg-gray-50 border-b border-gray-200 text-xs uppercase text-gray-500 font-semibold" data-id="element-4059">
              <th className="p-4 w-10" data-id="element-4060">
                <input type="checkbox" className="rounded border-gray-300" data-id="element-4061" />
              </th>
              <th className="p-4" data-id="element-4062">Image</th>
              <th className="p-4" data-id="element-4063">Name</th>
              <th className="p-4 text-center" data-id="element-4064">PDF</th>
              <th className="p-4" data-id="element-4065">Phone</th>
              <th className="p-4" data-id="element-4066">Contractor</th>
              <th className="p-4" data-id="element-4067">Contr. Prof.</th>
              <th className="p-4" data-id="element-4068">Sticker No.</th>
              <th className="p-4" data-id="element-4069">Site Name</th>
              <th className="p-4" data-id="element-4070">Specializ / Certification</th>
            </tr>
          </thead>
          <tbody className="text-sm text-gray-700" data-id="element-4071">
            {WORKERS.map(worker => <tr key={worker.id} className="border-b border-gray-100 hover:bg-gray-50 transition-colors" data-id="element-4072">
                <td className="p-4" data-id="element-4073">
                  <input type="checkbox" className="rounded border-gray-300" data-id="element-4074" />
                </td>
                <td className="p-4" data-id="element-4075">
                  <img src={worker.image} alt={worker.name} className="w-10 h-10 rounded object-cover border border-gray-200" data-id="element-4076" />
                </td>
                <td className="p-4 font-medium text-gray-900" data-id="element-4077">{worker.name}</td>
                <td className="p-4 text-center" data-id="element-4078">
                  <button className="text-gray-400 hover:text-gray-600" data-id="element-4079">
                    <Download size={18} data-id="element-4080" />
                  </button>
                </td>
                <td className="p-4 text-gray-500" data-id="element-4081">{worker.phone}</td>
                <td className="p-4" data-id="element-4082">{worker.contractor}</td>
                <td className="p-4" data-id="element-4083">{worker.prof}</td>
                <td className="p-4" data-id="element-4084">{worker.sticker}</td>
                <td className="p-4" data-id="element-4085">{worker.site}</td>
                <td className="p-4 text-gray-500" data-id="element-4086">{worker.role}</td>
              </tr>)}
          </tbody>
        </table>
      </div>

      {/* Pagination (Visual only) */}
      <div className="p-4 border-t border-gray-200 flex justify-between items-center text-sm text-gray-500" data-id="element-4087">
        <div data-id="element-4088">Showing 1-10 of 4681</div>
        <div className="flex gap-2" data-id="element-4089">
          <button className="px-3 py-1 border border-gray-300 rounded hover:bg-gray-50 disabled:opacity-50" disabled data-id="element-4090">
            Previous
          </button>
          <button className="px-3 py-1 border border-gray-300 rounded hover:bg-gray-50" data-id="element-4091">
            Next
          </button>
        </div>
      </div>
    </div>;
}